export default "__VITE_ASSET__8770efaf__"